// removed by extract-text-webpack-plugin
module.exports = {"title":"_1JNiC"};


//////////////////
// WEBPACK FOOTER
// ./app/components/PurchaseFAQ/PurchaseFAQ.scss
// module id = 1501
// module chunks = 1